import { useQuery } from "@tanstack/react-query"

import { client } from "@/api"
import queryKeys from "@/api/queryKeys"
import { remapRawServerEvent } from "@/common/utils"
import { RawServerEvent } from "@/common/types"

function useGetEvent(eventId: number) {
  return useQuery({
    queryKey: queryKeys.events.detail(eventId).queryKey,
    queryFn: () =>
      client.get(`/events/${eventId}`).then((response) => ({
        ...response.data,
        data: remapRawServerEvent(response.data.data as RawServerEvent),
      })),
  })
}
export default useGetEvent
